import React, { FC, useState, useEffect } from 'react';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import StarIcon from '@mui/icons-material/Star';
import './CommentList.scss';
import { initialState } from './CommentList.config';
import { SCUIContent } from '../../../atomic/organisms';
import StyleVariables from '../../../assets/styles/variables/_export.module.scss';
import { downloadExcel } from '../../../utils/excelFileHelper';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { useForm } from 'react-hook-form';
import PrintIcon from '@mui/icons-material/Print';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import DoneIcon from '@mui/icons-material/Done';
import { SCUIDateRanger, SCUIAutoCompleteInput } from '../../../atomic/atoms';
import {
    SCUICommentListForm,
    SCUIGrid,
    SCUIGeneralDrawer,
    SCUIProductCommentDetailForm,
    SCUIControllerSelectbox,
} from '../../../atomic/molecules';
import { Box, Fade, Grid, LinearProgress, Paper, TextField } from '@mui/material';
import { CommentQuery } from '../../../services/query';
import { OperatorQuery } from '../../../services/query';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from 'react-i18next';
import AndroidIcon from '@mui/icons-material/Android';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

import TimeHelper from '../../../utils/time';
import { parseCommentListParams } from './CommentList.helper';
import {
    enumCommentStatusFlowStatus,
    enumCommentStatusFlowStatusName,
    enumCommentStatusFlowStatusTrName,
    enumCommentRoleID,
    enumCommentGrievanceStatusFlowStatus,
    enumCommentGrievanceStatusFlowStatusName,
    enumAgenctStatusList,
} from '../../../types/enums/status';
import { enumCellType } from '../../../types/enums';

import { CommentCommand } from '../../../services/command';
import Swal from 'sweetalert2';
import { CL } from './commentList.classes';

export const CommentList: FC<any> = (props: any) => {
    const { t } = useTranslation();
    const commentStatusLookupList = [
        {
            id: enumCommentStatusFlowStatus.minusOne,
            value: t('general.all'),
        },
        {
            id: enumCommentStatusFlowStatus.one,
            value: t('general.waitingForApproval'),
        },
        {
            id: enumCommentStatusFlowStatus.two,
            value: t('general.approved'),
        },
        {
            id: enumCommentStatusFlowStatus.three,
            value: t('general.declined'),
        },
    ];

    const grievanceStatusLookupList = [
        {
            id: enumCommentGrievanceStatusFlowStatus.two,
            value: '-',
        },
        {
            id: enumCommentGrievanceStatusFlowStatus.one,
            value: t('general.var'),
        },
        {
            id: enumCommentGrievanceStatusFlowStatus.zero,
            value: t('general.giderildi'),
        },
    ];
    const grievanceStatusSelectBoxLookupList = [
        {
            id: enumCommentGrievanceStatusFlowStatus.two,
            value: t('general.all'),
        },
        {
            id: enumCommentGrievanceStatusFlowStatus.one,
            value: t('general.var'),
        },
        {
            id: enumCommentGrievanceStatusFlowStatus.zero,
            value: t('general.giderildi'),
        },
    ];
    const agentStatusList = [
        {
            id: enumAgenctStatusList.all,
            value: t('general.all'),
        },
        {
            id: enumAgenctStatusList.yes,
            value: t('general.yes'),
        },
        {
            id: enumAgenctStatusList.no,
            value: t('general.no'),
        },
    ];
    const [tagNames, setTagNames] = React.useState([]);
    const [tagName, setTagName] = React.useState<string[]>();
    const [commentDetailShow, setCommentDetailShow] = useState(false);
    const [commentFilterShow, setCommentFilterShow] = useState(false);
    const [commentDetailId, setCommentDetailId] = useState(0);
    const isTablet = useMediaQuery(`(max-width:  ${StyleVariables.breakpointMd})`, { noSsr: true });
    const [commentList, setCommentList] = useState(initialState.commentList);
    const [pageCount, setPageCount] = useState();
    const [param, setParam] = useState('');
    const [endDate, setEndDate] = useState('');
    const [createdDate, setCreatedDate] = useState('');
    const [colorCode, setColorCode] = useState('');
    const [specialCode, setSpecialCode] = useState('');
    const [commentStatus, setCommentStatus] = useState(initialState.filterInfo.commentStatus);
    const [grievanceStatus, setGrievanceStatus] = useState(initialState.filterInfo.grievanceStatus);
    const [urls, setUrls] = useState('');
    const [loading, setLoading] = useState(initialState.loading);
    const [excelLoading, setExcelLoading] = useState(initialState.loading);
    const [paginationInfo, setPaginationInfo] = useState(initialState.paginationInfo);
    const { control: filterFormControl } = useForm();
    const _handlChangeTag = (event: any, newValue: any) => {
        setTagName(
            newValue.map(function (item: any) {
                return item.id;
            })
        );
    };
    const handleDownloadExcel = async () => {
        try {
            setExcelLoading(true);
            downloadExcelHandler();
            await new Promise((resolve) => setTimeout(resolve, 2000));
        } catch (error) {
            console.error('Excel indirme hatası:', error);
        }
    };
    const _handlChangeDate = (event: any) => {
        setCreatedDate(event[0]);
        setEndDate(event[1]);
    };
    const [operators, setOperators] = React.useState([]);
    const [filterInfo, setFilterInfo] = useState(
        props.history.location.state?.filterInfo ? props.history.location.state?.filterInfo : initialState.filterInfo
    );
    let array_: any = [
        {
            applicationUserId: 1,
            combinedId: '',
            createDate: '',
            domainName: '',
            email: '',
            hrref: '?',
            isActive: true,
            updateDate: '',
            userRef: -1,
            username: '[' + t('general.selectUser') + ']',
        },
    ];

    let envType: string = import.meta.env.VITE_ENVIRONMENT!;
    const operatorRoleID = Object.entries(enumCommentRoleID).find(([key]) => key === envType)?.[1];
    const handleDeleteDrawerClose = () => setCommentDetailShow(false);
    const openCommentFilter = () => {
        setFilterInfo(initialState.filterInfo);
        setCommentFilterShow(true);
    };
    const closeCommentFilter = () => setCommentFilterShow(false);
    const _onChangePage = (key: string, value: number) => {
        setPaginationInfo((prevState: any) => ({ ...prevState, [key]: value }));
    };

    const _onSubmitFilterForm = () => {
        setFilterInfo({
            ...initialState.filterInfo,
            tagName: tagName,
            commentStatus: commentStatus,
            createDate: createdDate,
            endDate: endDate,
            colorCode: colorCode,
            specialCode: specialCode,
            grievanceStatus: grievanceStatus,
        });
    };

    const _onClickRowField = (rowId: string | number, cellInfo: any, rowInfo: any) => {
        if (cellInfo === 'Detay') {
            setCommentDetailId(rowInfo.id);
            setCommentDetailShow(true);
        }

        if (cellInfo === 'Bana Ata') {
            postAssignToMe(rowInfo);
        }
    };

    const postAssignToMe = async (rowInfo: any): Promise<any> => {
        let params = {
            rowId: Number(rowInfo.id),
            assignedOperator: rowInfo.operator,
        };
        CommentCommand.PostAssigToMe(params)
            .then((res: any) => {
                if (res) {
                    setCommentDetailId(rowInfo.id);
                    setCommentDetailShow(true);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: t('general.error'),
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }
            })
            .catch((error: any) => {
                Swal.fire({
                    icon: 'error',
                    title: t('general.error'),
                    showConfirmButton: false,
                    timer: 1500,
                });
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    const enumCommentName: any = {
        1: t('general.waitingForApproval'),
        2: t('general.approved'),
        3: t('general.declined'),
    };
    const downloadExcelHandler = () => {
        let url = urls.slice(31);
        url = 'size=' + pageCount + '&' + urls;
        CommentQuery.GetCommentData(url).then((res: any) => {
            if (res) {
                let parseData = res.data.map((item: any) => {
                    return {
                        'Yorum Id': item.id || '-',
                        Mail: item.userEmail || '-',
                        'Özel Kod': item.specialCode || '-',
                        'Renk Kod': item.colorcode || '-',
                        'Yorum Tarihi': TimeHelper.formatDateHour(item.commentDate) || '-',
                        'Mağduriyet Durumu': grievanceStatusLookupList[item.grievanceStatus]?.value || '-',
                        Puan: item.starScore || '-',
                        'Yorum Statü': enumCommentStatusFlowStatusTrName[item.status],
                        Etiket: item.tagName || '-',
                        'Atanan Kişi': item?.userOperatorName || '-',
                        'Ürün Yorumu': item.commentText || '-',
                        'Değiştirilme tarihi': TimeHelper.formatDateHour(item.changeOn) || '-',
                        'Müşteri Id': item.customerId || '-',
                        'Mağduriyet Açıklaması': item.grievanceStatusText || '-',
                        'Eşik Değeri': item?.threshold !== null ? item.threshold.toString() : '-',
                        'Etiket Olasılık Değeri': item.labelProp !== null ? item.labelProp.toString() : '-',
                        Marka: item.brandName !== null ? item.brandName : '-',
                        IsAgent: item.isAgent == null ? true : item.isAgent,
                    };
                });
                downloadExcel({
                    excelDownloadData: parseData,
                    excelDownloadFolderName: 'CommentList',
                });
                setExcelLoading(false);
            }
        });
    };

    const GetCommentTicketList = async () => {
        try {
            let commentText: any = await CommentQuery.GetCommentTicketList();
            setTagNames(commentText.data);
        } catch (error) {
            console.log('Hata :>> ', error);
        }
    };

    const getOperatorListByRoleId = async () => {
        try {
            let operator: any = await OperatorQuery.GetOperatorListByRoleId(operatorRoleID);
            let arr: any = [...array_, ...operator.model.data];
            setOperators(arr);
        } catch (error) {
            console.log('Hata :>> ', error);
        }
    };
    useEffect(() => {
        GetCommentTicketList();
        getCommentList();
        getOperatorListByRoleId();
    }, []);

    useEffect(() => {
        getCommentList();
    }, [filterInfo, paginationInfo.rowsPerPage, paginationInfo.currentPage]);
    const filterData = (filteredInfo: any) => {
        paginationInfo.currentPage = 0;
        setFilterInfo(filteredInfo);
    };
    const getCommentList = () => {
        if (!loading) {
            setLoading(true);
            let param: any = parseCommentListParams(
                paginationInfo,
                filterInfo.optionId,
                filterInfo.specialCode,
                filterInfo.colorCode,
                filterInfo.createDate,
                filterInfo.endDate,
                filterInfo.starScore,
                filterInfo.commentStatus,
                filterInfo.tagName,
                filterInfo.operator,
                filterInfo.grievanceStatus,
                filterInfo.isAgent
            );

            CommentQuery.GetCommentData(param)
                .then((res: any) => {
                    if (res) {
                        let parseData = res.data.map((item: any) => {
                            return {
                                id: item.id || '-',
                                mail: item.userEmail || '-',
                                brandName: item.brandName || '-',
                                special: item.specialCode || '-',
                                colorCode: item.colorcode || '-',
                                createDate: TimeHelper.formatDateHour(item.commentDate) || '-',
                                status: item.starScore || '-',
                                isAgent: item.isAgent ? (
                                    <SupportAgentIcon sx={{ cursor: 'default', width: 150, height: 150 }} />
                                ) : (
                                    <AndroidIcon style={{ color: 'turquoise' }} />
                                ),
                                threshold: item.threshold ? '%' + (item.threshold * 100).toString() : '-',
                                labelProp: item.labelProp ? '%' + (item.labelProp * 100).toString() : '-',
                                commentStatus: {
                                    text: enumCommentName[item?.status],
                                    className: enumCommentStatusFlowStatusName[item?.status]?.statusType,
                                    id: item?.status,
                                },
                                tag: item.tagName || '-',
                                operator: item?.userOperatorName || '-',
                                detay: 'Detay',
                                banaAta: 'Bana Ata',
                                grievanceStatus: {
                                    text:
                                        item?.status != 0
                                            ? grievanceStatusLookupList[item?.grievanceStatus]?.value
                                            : '',
                                    className:
                                        enumCommentGrievanceStatusFlowStatusName[item?.grievanceStatus]?.statusType,
                                    id: item?.grievanceStatus,
                                },
                            };
                        });
                        setCommentList(parseData);
                        let totalCounts = res.count;
                        let pageSize = res.take;
                        setPageCount(res.count);
                        setPaginationInfo({
                            rowsPerPage: pageSize,
                            pageCount: res.totalPages,
                            totalCount: totalCounts,
                            currentPage: paginationInfo.currentPage,
                        });

                        setParam(param);
                        setUrls('' + param);
                    }
                })
                .catch((error: any) => {
                    console.log('Hata :>> ', error);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };
    return (
        <SCUIContent className={CL.page}>
            <SCUIGeneralDrawer
                open={commentDetailShow}
                anchor="right"
                width={isTablet ? '100%' : '80rem'}
                paperClassName={CL.detailDrawerPaper}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        handleDeleteDrawerClose();
                    }
                }}
            >
                <div className={CL.detailDrawerContent}>
                    <SCUIProductCommentDetailForm id={commentDetailId} onClose={handleDeleteDrawerClose} />
                </div>
            </SCUIGeneralDrawer>
            <SCUIGeneralDrawer
                anchor="right"
                open={commentFilterShow}
                width="35%"
                paperClassName={CL.filterDrawerPaper}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        closeCommentFilter();
                    }
                }}
            >
                <div className={CL.filterDrawerContent}>
                    <SCUICommentListForm
                        formFilterInfo={filterData}
                        tagNames={tagNames}
                        operators={operators}
                        param={param}
                        myFilterInfo={filterInfo}
                        agentStatuses={agentStatusList}
                        grievanceStatusList={grievanceStatusSelectBoxLookupList}
                        onClose={closeCommentFilter}
                    />
                </div>
            </SCUIGeneralDrawer>
            <Grid className={CL.excelLoadingSection}>
                <Box>
                    <Fade style={{ marginBottom: '5rem' }} in={excelLoading} unmountOnExit>
                        <LinearProgress className={CL.excelLoadingBar} />
                    </Fade>
                </Box>
            </Grid>
            <Grid className={CL.filtersLayout} container spacing={5}>
                <Grid
                    size={{
                        md: 12,
                        xs: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <h1 className={[CL.headerTitle, 'headtxt'].join(' ')}>{t('dashboard.comments')}</h1>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        md: 6,
                        lg: 3,
                        xl: 2,
                    }}
                >
                    <div className={CL.tagAutocompleteWrap}>
                        <SCUIAutoCompleteInput
                            list={tagNames}
                            onChange={_handlChangeTag}
                            limitTags={1}
                            txtPlaceHolder={t('general.tag')}
                            searchValue="keyWord"
                        />
                    </div>
                </Grid>

                <Grid
                    size={{
                        xs: 12,
                        md: 6,
                        lg: 3,
                        xl: 2,
                    }}
                >
                    <div className={CL.dateRangeWrap}>
                        <SCUIDateRanger setDateRange={_handlChangeDate} dateFormat="YYYY-MM-DD" />
                    </div>
                </Grid>

                <Grid
                    size={{
                        xs: 12,
                        md: 6,
                        lg: 3,
                        xl: 2,
                    }}
                >
                    <div className={CL.statusSelectWrap}>
                        <SCUIControllerSelectbox
                            fullWidth
                            name="commentStatus"
                            label={t('comments.selectStatus')}
                            selectList={filterInfo.commentStatus}
                            list={commentStatusLookupList}
                            formControl={filterFormControl}
                            value={'Statu Seçiniz'}
                            stateName={'commentStatus'}
                            size={'m'}
                            onChange={(e: any) => {
                                setCommentStatus(e);
                            }}
                        />
                    </div>
                </Grid>

                {grievanceStatusSelectBoxLookupList && (
                    <Grid
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 3,
                            xl: 2,
                        }}
                    >
                        <div className={CL.grievanceSelectWrap}>
                            <SCUIControllerSelectbox
                                fullWidth
                                name="grievanceStatus"
                                label={t('comments.grievance')}
                                selectList={filterInfo.grievanceStatus}
                                list={grievanceStatusSelectBoxLookupList}
                                formControl={filterFormControl}
                                value={'comments.grievance'}
                                stateName={'grievanceStatus'}
                                size={'m'}
                                onChange={(e: any) => {
                                    setGrievanceStatus(e);
                                }}
                            />
                        </div>
                    </Grid>
                )}

                <Grid
                    size={{
                        xs: 6,
                        md: 6,
                        lg: 3,
                        xl: 1,
                    }}
                >
                    <TextField
                        className={CL.inputSpecialCode}
                        fullWidth
                        slotProps={{ inputLabel: { shrink: true } }}
                        label={t('comments.specialCode')}
                        variant={'outlined'}
                        onChange={(e: any) => setSpecialCode(e.target.value)}
                    />
                </Grid>
                <Grid
                    size={{
                        xs: 6,
                        md: 6,
                        lg: 3,
                        xl: 1,
                    }}
                >
                    <TextField
                        className={CL.inputColorCode}
                        fullWidth
                        slotProps={{ inputLabel: { shrink: true } }}
                        label={t('comments.colorCode')}
                        variant={'outlined'}
                        onChange={(e: any) => setColorCode(e.target.value)}
                    />
                </Grid>
                <Grid
                    size={{
                        md: 6,
                        xs: 6,
                        lg: 2,
                    }}
                >
                    <Stack className={CL.actionsWrap} direction="row" spacing={2}>
                        <IconButton className={CL.applyQuickFilterButton} aria-label="delete">
                            <DoneIcon className="svg_icons" onClick={_onSubmitFilterForm} />
                        </IconButton>
                        <IconButton
                            className={CL.openAdvancedFilterButton}
                            aria-label="filter"
                            onClick={openCommentFilter}
                        >
                            <FilterAltOutlinedIcon className="svg_icons" />
                        </IconButton>

                        <IconButton className={CL.exportExcelButton} aria-label="filter" onClick={handleDownloadExcel}>
                            <PrintIcon className="svg_icons" />
                        </IconButton>
                    </Stack>
                </Grid>
            </Grid>
            <Paper className={CL.tablePaper} sx={{ padding: '2rem', margin: '2rem', width: '100%' }}>
                <div className={CL.gridWrap}>
                    <SCUIGrid
                        rows={commentList}
                        headCells={[
                        {
                            id: 'id',
                            numeric: false,
                            disablePadding: true,
                            label: t('comments.commentId'),
                            cellType: enumCellType.string,
                        },
                        {
                            id: 'mail',
                            numeric: false,
                            disablePadding: true,
                            label: t('general.eMail'),
                            cellType: enumCellType.string,
                        },
                        {
                            id: 'brandName',
                            numeric: false,
                            disablePadding: true,
                            label: t('general.brand'),
                            cellType: enumCellType.string,
                        },
                        {
                            id: 'special',
                            numeric: false,
                            disablePadding: true,
                            label: t('comments.specialCode'),
                            cellType: enumCellType.string,
                        },
                        {
                            id: 'colorCode',
                            numeric: false,
                            disablePadding: true,
                            label: t('comments.colorCode'),
                            cellType: enumCellType.string,
                        },
                        {
                            id: 'commentStatus',
                            numeric: false,
                            disablePadding: true,
                            label: t('comments.commentStatus'),
                            cellType: enumCellType.status,
                        },
                        {
                            id: 'status',
                            numeric: false,
                            disablePadding: true,
                            label: t('general.point'),
                            icon: StarIcon,
                            cellType: enumCellType.icons,
                        },
                        {
                            id: 'createDate',
                            numeric: false,
                            disablePadding: true,
                            label: t('comments.commentDate'),
                            cellType: enumCellType.string,
                        },
                        {
                            id: 'grievanceStatus',
                            numeric: false,
                            disablePadding: true,
                            label: t('comments.grievance'),
                            cellType: enumCellType.status,
                        },
                        {
                            id: 'operator',
                            numeric: false,
                            disablePadding: true,
                            label: t('general.operator'),
                            cellType: enumCellType.string,
                        },
                        {
                            id: 'tag',
                            numeric: false,
                            disablePadding: true,
                            label: t('general.tag'),
                            cellType: enumCellType.string,
                        },
                        {
                            id: 'isAgent',
                            numeric: false,
                            disablePadding: true,
                            label: 'IsAgent',
                            cellType: enumCellType.string,
                        },
                        {
                            id: 'threshold',
                            numeric: false,
                            disablePadding: true,
                            label: 'Eşik Değeri',
                            cellType: enumCellType.string,
                        },
                        {
                            id: 'labelProp',
                            numeric: false,
                            disablePadding: true,
                            label: 'Etiket Olasılık Değeri',
                            cellType: enumCellType.string,
                        },
                        {
                            id: 'detay',
                            numeric: false,
                            disablePadding: true,
                            label: t('general.detail'),
                            icon: AssignmentIcon,
                            cellType: 1,
                        },
                        {
                            id: 'banaAta',
                            numeric: false,
                            disablePadding: true,
                            label: t('general.assignToMe'),
                            icon: AssignmentIndIcon,
                            cellType: 1,
                        },
                    ]}
                        onChangePage={_onChangePage}
                        paginationInfo={paginationInfo}
                        //  onClickRow={_onClickSelectedRow}
                        onClickRowField={_onClickRowField}
                        loading={loading}
                    />
                </div>
            </Paper>
        </SCUIContent>
    );
};
